import React from 'react';
import ApproveIpnaItem from './ApproveIpnaItem.jsx'
import TablePagination from 'components/Pagination/TablePagination';
import Headers from './Headers'

export const ApproveIpnaList = ({
                           users,
                           checkedUserIds,
                           user_ids,
                           paginationProps,
                           onOrderChange,
                           query,
                           onDisciplineApprove,
                           onDisciplineReject
                         })  => <table>
  <Headers
    onChange={onOrderChange}
    value={query.order}
  />
  { users.map(user => (
    <ApproveIpnaItem
      user={user}
      checkedUserIds={checkedUserIds}
      key={user.id}
      user_ids={user_ids}
      onDisciplineApprove={onDisciplineApprove}
      onDisciplineReject={onDisciplineReject}
    />
  ))}
  <tr>
    <td colSpan="9">
      <TablePagination
        {...paginationProps}
      />
    </td>
  </tr>
</table>



// WEBPACK FOOTER //
// ./src/components/Admin/ApproveIpna/ApproveIpnaList.jsx